import { CamelCaseKeys, PaymentWaiverReasonEnum } from '@uplift/types';

import { restClient } from '../../client';
import { Appointment, CPTCode, PaymentTypeName, PublicUser, Session } from '../../resources';
import { MedicalNote } from '../medical-notes';

export enum ProviderFinancePeriodItemType {
  cancelledSession = 'cancelled_session',
  completedSession = 'completed_session',
  billableClinicalNote = 'billable_clinical_note',
}


type _ProviderFinancePeriodItemBase = {
  item_type: ProviderFinancePeriodItemType;
  patient?: PublicUser;
  submitted_at: string;
  address_state?: string;
  payment: {
    type: PaymentTypeName;
    payment_waiver_reason: PaymentWaiverReasonEnum;
    refunded_at: string;
  };
  cpt_codes: CPTCode[];
  payout_amount: number;
  paid: boolean;
  payoutDate: string;
};

export type ProviderFinancePeriodItemAppointment = CamelCaseKeys<_ProviderFinancePeriodItemBase & {
  item_type: ProviderFinancePeriodItemType.cancelledSession | ProviderFinancePeriodItemType.completedSession;
  appointment: Appointment;
  session: Session;
}>;

export type ProviderFinancePeriodItemNote = CamelCaseKeys<_ProviderFinancePeriodItemBase & {
  item_type: ProviderFinancePeriodItemType.billableClinicalNote;
  note: MedicalNote;
}>;

export type ProviderFinancePeriodItem = ProviderFinancePeriodItemAppointment | ProviderFinancePeriodItemNote;


export type ProviderFinancePeriod = CamelCaseKeys<{
  started: string;
  ended: string;
  payout: number;
  sessions: number;
  paid: number;
  lateFees: number;
  items: ProviderFinancePeriodItem[];
}>;


export type FinancePaymentDashboardPeriods = {
  providerId: string;
  last: ProviderFinancePeriod;
  this: ProviderFinancePeriod;
  paid: number;
};

/**
 * used for generating the monthly finance report with no schedule changes
 */
export const getFinancePaymentDashboard = (providerId: string, data?: { current_date: string }) =>
  restClient.request<{ data: FinancePaymentDashboardPeriods }>(`/api/v1/provider/${providerId}/finances/for-period`, {
    params: data ?? {}
  });

/**
 * used for displaying dashboard page periods that reflect 2 weeks of arrears payouts
 */
export const getFinanceDisplayPeriods = async (providerId: string, data?: { current_date: string }) =>
  restClient.request<{ data: FinancePaymentDashboardPeriods }>(`/api/v1/provider/${providerId}/finances/display-periods`, {
    params: data ?? {}
  });
